import Unsplash, { toJson } from 'unsplash-js'
import { unsplashConfig } from '../config'

export default class UnsplashApi {
  constructor () {
    this.unsplash = new Unsplash({
      applicationId: unsplashConfig.appId,
      secret: unsplashConfig.secret,
      headers: {
        Authorization: 'Client-ID ' + unsplashConfig.appId
      }
    })
  }

  getRandomUnsplashPhotos (query) {
    return new Promise((resolve, reject) => {
      this.unsplash.photos
        .getRandomPhoto({ count: 25, orientation: 'landscape', query: query })
        .then(toJson)
        .then(json => {
          resolve(json)
        })
        .catch(e => {
          return reject(e.error)
        })
      setTimeout(function () {
        return reject('ERROR TIMEOUT')
      }, 2000)
    })
  }
}



// WEBPACK FOOTER //
// src/libs/unsplash.js